import { PHONE_DISPLAY, PHONE_TEL, TID } from "@/config/site";
import { Phone, MessageSquare } from "lucide-react";
import ShareLocationButton from "@/components/site/ShareLocationButton";

export default function MobileCallBar() {
  return (
    <div
      data-testid={TID.mobileCallBar}
      role="region"
      aria-label="Emergency call bar — call BM Towing 24/7"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 lux-glass-strong border-t border-yellow-400/40 p-2 grid grid-cols-6 gap-2"
      style={{ paddingBottom: "max(0.5rem, env(safe-area-inset-bottom))" }}
    >
      <a
        href={`tel:${PHONE_TEL}`}
        data-testid={TID.mobileCallBtn}
        className="col-span-3 inline-flex items-center justify-center gap-2 bg-yellow-400 hover:bg-yellow-300 text-black font-display font-black uppercase tracking-wider px-3 py-3 rounded-full lux-glow-yellow min-h-[52px] text-sm transition-colors focus:outline-none focus-visible:ring-4 focus-visible:ring-yellow-300"
        aria-label={`Call BM Towing 24/7 at ${PHONE_DISPLAY}`}
      >
        <Phone className="h-5 w-5" strokeWidth={3} aria-hidden="true" />
        Call
      </a>
      <ShareLocationButton
        testId={TID.mobileShareLocationBtn}
        variant="mobile"
        label="Share GPS"
        className="col-span-2"
      />
      <a
        href="#contact"
        data-testid={TID.mobileQuoteBtn}
        aria-label="Request a quote — jump to contact form"
        className="col-span-1 inline-flex items-center justify-center gap-1 lux-glass text-yellow-400 border border-yellow-400/40 font-display font-black uppercase tracking-wider px-1 py-3 rounded-full text-[10px] min-h-[52px] focus:outline-none focus-visible:ring-4 focus-visible:ring-yellow-300"
      >
        <MessageSquare className="h-4 w-4" strokeWidth={3} aria-hidden="true" />
        Quote
      </a>
    </div>
  );
}
